export interface IQueryList {
  id: number;
  dataset: string;
  table_label: string;
  query_name: string;
  description: string;
  deleted: number;
  context_id: string;
  user_id: string;
}

export interface IQueryCreation {
  name: string;
  label: string;
  fields: IQueryType[];
}

export interface IQueryType {
  label: string;
  name: string;
  type: string;
}

export interface IQueryDataset {
  label: string;
  name: string;
  type: string;
  queryable?: boolean;
  icon?: string;
  isSvg?: boolean;
}

export interface IQueryCond {
  comparison: string;
  field: string;
  value: any;
  operator: any;
  position: number;
  field_type: string;
}

export interface IQueryOrder {
  field: string;
  position: number;
  value: string;
}
